(() => {
  // Shopify theme-editor reloads must not duplicate listeners or active fetches.
  if (window.__wikiDocumentationAdapter) { window.__wikiDocumentationAdapter.scan(document); return; }
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const form = root.querySelector('.aw-search');
    const input = form?.querySelector('input');
    if (!input) return;
    const nav = root.querySelector('[data-aw-nav]');
    const results = root.querySelector('[data-aw-results]');
    const status = root.querySelector('[data-aw-status]');
    const matches = root.querySelector('[data-aw-matches]');
    const clear = root.querySelector('[data-aw-clear]');
    const retry = root.querySelector('[data-aw-retry]');
    const fallback = [...nav.querySelectorAll('a')].map((a) => ({ title: a.dataset.awTitle, description: a.dataset.awDescription, url: a.getAttribute('href'), searchableText: '' }));
    const controller = new AbortController();
    let index = null;
    let loading = false;
    let failed = false;
    const safeUrl = (value) => typeof value === 'string' && /^\/pages\/[a-z0-9-]+$/.test(value);
    function searchUrl(value) {
      if (!safeUrl(value)) throw new Error('Unsafe search destination.');
      if (!root.dataset.awPreviewCarrier) return value;
      // Preview mode is explicit and restricted to the generated route allowlist.
      const carrier = root.dataset.awPreviewCarrier;
      const theme = root.dataset.awPreviewTheme;
      const views = JSON.parse(root.dataset.awPreviewViews ?? '{}');
      const route = views[value];
      const view = typeof route === 'string' ? route : route?.view;
      const doc = typeof route === 'object' && route !== null ? route.doc : undefined;
      if (!safeUrl(carrier) || !/^\d+$/.test(theme ?? '') || typeof view !== 'string' || !/^[a-z0-9-]{1,25}$/.test(view) || (doc !== undefined && (typeof doc !== 'string' || !/^[a-z0-9-]+$/.test(doc)))) throw new Error('Invalid preview route.');
      return `${carrier}?view=${view}${doc ? `&doc=${encodeURIComponent(doc)}` : ''}&preview_theme_id=${theme}`;
    }
    function render() {
      const query = input.value.trim().toLowerCase();
      results.hidden = !query;
      nav.hidden = !!query;
      clear.hidden = !input.value;
      retry.hidden = !failed || !query;
      matches.replaceChildren();
      if (!query) return;
      const found = (index ?? fallback).filter((page) => `${page.title} ${page.description} ${page.searchableText ?? ''}`.toLowerCase().includes(query));
      status.textContent = loading ? 'Searching all sample content…' : failed ? `Full-text search unavailable. ${found.length} title match(es).` : `${found.length} result${found.length === 1 ? '' : 's'}`;
      if (!found.length && !loading && !failed) status.textContent = 'No matching documentation page.';
      for (const page of found) {
        const a = document.createElement('a');
        a.href = page.url;
        const title = document.createElement('strong');
        title.textContent = page.title;
        const description = document.createElement('small');
        description.textContent = page.description;
        a.append(title, description);
        matches.append(a);
      }
    }
    async function load() {
      if (loading || index) return;
      loading = true;
      failed = false;
      render();
      try {
        if (!root.dataset.awIndexUrl) throw new Error('Search index is not configured.');
        const response = await fetch(root.dataset.awIndexUrl, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) throw new Error('Search index is unavailable.');
        const data = await response.json();
        if (!Array.isArray(data) || !data.every((page) => typeof page.title === 'string' && typeof page.description === 'string' && typeof page.searchableText === 'string' && safeUrl(page.url))) throw new Error('Invalid search index.');
        index = data.map((page) => ({ ...page, url: searchUrl(page.url) }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        failed = true;
      } finally {
        loading = false;
        if (!controller.signal.aborted) render();
      }
    }
    form.addEventListener('submit', (event) => event.preventDefault(), { signal: controller.signal });
    input.addEventListener('input', () => { render(); if (input.value.trim() && !index && !failed) void load(); }, { signal: controller.signal });
    clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); }, { signal: controller.signal });
    retry.addEventListener('click', () => void load(), { signal: controller.signal });
    instances.set(root, () => controller.abort());
    render();
  }
  function scan(container) {
    if (container.matches?.('[data-aw-root]')) init(container);
    container.querySelectorAll('[data-aw-root]').forEach(init);
  }
  window.__wikiDocumentationAdapter = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, dispose] of instances) if (event.target.contains(root)) { dispose(); instances.delete(root); }
  });
})();
